<template>
  <div class="youtubeContainer">
    <iframe
      class="youtubePlayer"
      width="560"
      height="315"
      :src="embedLink"
      title="YouTube video player"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    ></iframe>
  </div>
</template>



<script>
import jQuery from "jquery";
import ReRenderer from "../../mixins/re-renderer.vue";
import { converYoutubeLinkToEmbedLink, converYoutubeShortsLinkToEmbedLink, converYoutubeLiveLinkToEmbedLink, converDefaultYoutubeLinkToEmbedLink }  from "../../../../helpers/formatters.js";
export default {
  mixins: [ReRenderer],
  components: {},
  props: ["postID", "link"],
  data() {
    return {
      reRenderCssSelectors: [
        {
          jquerySelectors: ".youtubeContainer",
          properties: [
            {
              propertyName: "height",
              propertyValue: this.getWindowHeightInPx,
              isCallBack: true,
            },
          ],
        },
      ],
    };
  },
  computed: {
    embedLink(){
      let isShort = this.link.toLowerCase().includes("shorts");
      let isLive = this.link.toLowerCase().includes("live");

      if (isShort){
      return converYoutubeShortsLinkToEmbedLink(this.link);
      }
      else if (isLive) {
        return converYoutubeLiveLinkToEmbedLink(this.link);
      }
      else if (!isShort && !isLive) {
        return converDefaultYoutubeLinkToEmbedLink(this.link);
      }
      else {
        return converYoutubeLinkToEmbedLink(this.link);
      }
    }
  },
  mounted() {
    jQuery(document).ready(function () {
      jQuery(".youtubeContainer").css("height", jQuery(window).height() + "px");
    });
  },
};
</script>



<style scoped>
.youtubeContainer {
  width: 500px;
  position: relative;
  /* white-space: nowrap; */
}

.youtubePlayer {
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
  /* object-fit: cover; */
  width: 100%;
  max-height: 90vh;
  /* vertical-align: middle; */
}



</style>
